import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/tag-icon'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(tag) {
    return http.post(`${resource}`, tag)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
